<template>
  <Events :editMode="hasRole(roles_.teacher)"></Events>
</template>

<script>
import { mapGetters } from 'vuex'
import Events from '@/components/content/events/AllEvents.vue'
import { roles } from '@/config/roles'

export default {
  name: 'ClassEvents',
  components: { Events },
  data() {
    return {
      roles_: roles
    }
  },
  computed: {
    ...mapGetters({
      hasRole: 'currentUser/hasRole'
    })
  }
}
</script>

<style scoped>

</style>
